import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import { __assign, __decorate, __extends } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import wrapper from './index.vue';
import consumables from './consumables/index.vue';
import { namespace } from 'vuex-class';
var User = namespace('user');

var WrapperInboundListPage = function (_super) {
  __extends(WrapperInboundListPage, _super);

  function WrapperInboundListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeTab = '';
    return _this;
  }

  Object.defineProperty(WrapperInboundListPage.prototype, "tabList", {
    get: function get() {
      var _this = this;

      return this.$util.filterListPermission([{
        text: this.tc('包材'),
        value: 'wrapper',
        isShow: function isShow() {
          return _this.showWrapper;
        },
        _permissionKey: 'wrapper_inbound_view'
      }, {
        text: this.tc('耗材'),
        value: 'consumables',
        isShow: function isShow() {
          return _this.showConsumables;
        },
        _permissionKey: 'consumable_inbound_view'
      }]).filter(function (item) {
        return item.isShow ? item.isShow() : true;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WrapperInboundListPage.prototype, "showWrapper", {
    get: function get() {
      return !!this.customerInfo.is_sku_wrapper_activate;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WrapperInboundListPage.prototype, "showConsumables", {
    get: function get() {
      return !!this.customerInfo.is_push_card_activate;
    },
    enumerable: false,
    configurable: true
  });

  WrapperInboundListPage.prototype.handleChange = function (value) {
    this.activeTab = value;
    this.$router.push({
      name: 'WrapperInboundListPage',
      query: __assign(__assign({}, this.$route.query), {
        pageType: value
      })
    });
  };

  WrapperInboundListPage.prototype.handleSwitchTab = function (componentName) {
    this.activeTab = componentName;
  };

  WrapperInboundListPage.prototype.initActiveTab = function () {
    var _this = this;

    var pageType = this.$route.query.pageType;
    this.$nextTick(function () {
      var tabList = _this.tabList.filter(function (item) {
        return item.value.toString() === pageType;
      });

      _this.activeTab = tabList.length ? tabList[0].value.toString() : _this.tabList[0].value.toString();
    });
  };

  WrapperInboundListPage.prototype.handleCustomerInfoChange = function () {
    this.initActiveTab();
  };

  __decorate([User.State('customerInfo')], WrapperInboundListPage.prototype, "customerInfo", void 0);

  __decorate([Watch('customerInfo', {
    immediate: true,
    deep: false
  })], WrapperInboundListPage.prototype, "handleCustomerInfoChange", null);

  WrapperInboundListPage = __decorate([Component({
    components: {
      wrapper: wrapper,
      consumables: consumables
    }
  })], WrapperInboundListPage);
  return WrapperInboundListPage;
}(Vue);

export default WrapperInboundListPage;